export default __webpack_public_path__ + "static/media/banner_scan-01.a64485f8.png";